import {
  Box,
  Stack,
  TextField,
  Typography,
} from "@mui/material";

interface DayOfWeekDateRangesEditorProps {
  value: Record<string, { startDate: string; endDate: string }>;
  onChange: (v: Record<string, { startDate: string; endDate: string }>) => void;
}

export const DayOfWeekDateRangesEditor = ({
  value,
  onChange,
}: DayOfWeekDateRangesEditorProps) => {
  const days = [
    "monday",
    "tuesday",
    "wednesday",
    "thursday",
    "friday",
    "saturday",
    "sunday",
  ];

  const setDate = (day: string, key: "startDate" | "endDate", val: string) =>
    onChange({
      ...(value || {}),
      [day]: {
        ...(value?.[day] || { startDate: "", endDate: "" }),
        [key]: val,
      },
    });

  return (
    <Box sx={{ border: 1, borderColor: "divider", p: 2, borderRadius: 2 }}>
      <Stack spacing={1}>
        {days.map((d) => (
          <Stack key={d} direction="row" spacing={1} alignItems="center">
            <Typography
              variant="body2"
              sx={{ minWidth: 100, textTransform: "capitalize" }}
            >
              {d}
            </Typography>
            <TextField
              size="small"
              type="date"
              value={value?.[d]?.startDate || ""}
              onChange={(e) => setDate(d, "startDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
            <TextField
              size="small"
              type="date"
              value={value?.[d]?.endDate || ""}
              onChange={(e) => setDate(d, "endDate", e.target.value)}
              InputLabelProps={{ shrink: true }}
            />
          </Stack>
        ))}
      </Stack>
    </Box>
  );
};
